export type DefaultExpirationDay =
  | 'sunday'
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'

export interface RateSetStatus {
  color: 'green' | 'red' | 'orange'
  status: 'warning' | 'success' | 'error'
  text:
    | 'Published'
    | 'Published (Pending Review)'
    | 'Needs Review'
    | 'Needs Entry'
}

export const rateSetStatuses: { [key: string]: RateSetStatus } = {
  NEED_ENTRY: {
    text: 'Needs Entry',
    status: 'error',
    color: 'red'
  },
  NEED_QC: {
    text: 'Needs Review',
    status: 'error',
    color: 'red'
  },
  PUBLISHED_QC: {
    text: 'Published (Pending Review)',
    status: 'warning',
    color: 'orange'
  },
  PUBLISHED: {
    text: 'Published',
    status: 'success',
    color: 'green'
  }
}
